"use client";

import { useSearchParams } from "next/navigation";
import { Suspense } from "react";

type Props = {
  paramName: string | string[];
  className: string;
  children: React.ReactNode;
};

function BorderHas({ paramName, className, children }: Props) {
  const searchParams = useSearchParams();
  const hasParamName =
    typeof paramName === "string" ? searchParams.has(paramName) : paramName.some((s) => searchParams.has(s));

  return (
    <div
      className={`${
        hasParamName ? "border-accent hover:bg-accent" : "border-secondary hover:bg-secondary"
      } ${className}`}
    >
      {children}
    </div>
  );
}

export function BorderHasSearchParamName(props: Props) {
  return (
    <Suspense fallback={<div className={`border-secondary ${props.className}`}>{props.children}</div>}>
      <BorderHas {...props} />
    </Suspense>
  );
}
